<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">{{form.ctype!=0?'合同会签审批表':'合同备案审批表'}}</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回合同详情</a>
    </div>
    <div class="form-content" v-if="contract.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">

          <el-form ref="form" v-if="form.ctype!=0" label-width="140px" class="form" style="margin-bottom:-25px;">
            <el-form-item label="需求类型">
              <el-radio-group v-model="contractType" class="type-radio-type">
                <el-radio-button label="1">集团审批</el-radio-button>
                <el-radio-button label="2">子公司内部审批</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <create-contract-approval ref="create" :project="contract" :userData="userData" :formByFather="form">
          </create-contract-approval>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='11'></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">
                <!-- {{form.ctype!=0?'合同会签审批表':'合同备案审批表'}} -->
                {{form.ctype!=0?'确认提交合同会签审批表':'确认提交合同备案审批表'}}
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'
  import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItem from '../../components/ApprovalItem'
  import CreateContractApproval from '../form/createContractApproval'
  export default {
    props: ['ctype'],
    components: {
      ApprovalItem,
      CreateContractApproval,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        contractType: 1,

        contract: {},
        form: {
          ctype: 1,
          isYhyb: '0',
          contractId: '',
          name: '',
          number: '',
          type: 0,
          customer: '',
          price: '',
          isBigCustomer: '0',
          isBigContract: '0',
          outline: '',
          content: '',
          remark: '',
          cbdw: '',
          cbr: '',
          cbdwfzr: '',

          // 是否8万以下工程，5万以下设计监理
          isLowcost: false,

          // 是否线下审批通过
          underLine: "",
        },
        hasApplyId: '',
        approvalUsersData: [],

        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
      }
    },
    created() {
      this.form.contractId = this.$route.params.contractId
      if (this.ctype != undefined) {
        this.form.ctype = this.ctype
      }
      this.getProject()
      this.getApplyData()
    },
    mounted() {
      this.approvalUsersData = this.approvalUsers['c31_' + this.form.ctype]
      console.log(this.form.ctype)
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.$route.params.applyId ? true : false
        this.form.signId = this.$route.params.applyId
        if (this.form.signId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          // 获取合同详情
          console.log("new contract")
          this.setSelectArr(this.applyInfo, 31, this.form.ctype / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/gc/project/contractsign/info/' + this.form.signId, '', (res) => {
          this.applyInfo = res.vo

          this.form.ctype = this.applyInfo.ctype
          this.form.isYhyb = this.applyInfo.isYhyb ? this.applyInfo.isYhyb.toString() : '0'

          this.form.name = this.applyInfo.name
          this.form.number = this.applyInfo.number
          this.form.type = this.applyInfo.type / 1;
          this.form.customer = this.applyInfo.customer

          this.form.price = this.applyInfo.price
          this.form.isBigCustomer = this.applyInfo.isBigCustomer.toString()
          this.form.isBigContract = this.applyInfo.isBigContract.toString()
          this.form.outline = this.applyInfo.outline
          this.form.content = this.applyInfo.content

          this.form.remark = this.applyInfo.remark
          this.form.cbdw = this.applyInfo.cbdw
          this.form.cbr = this.applyInfo.cbr
          this.form.cbdwfzr = this.applyInfo.cbdwfzr

          this.form.isLowcost = this.applyInfo.isLowcost == 1 ? true : false

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString()

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, 31, this.form.ctype / 1)
          this.formLoading = false
        })
      },
      // 获取合同详情
      getProject() {
        ajax.get('/contract/info/' + this.form.contractId, '', (res) => {
          this.contract = res.vo
          this.contract.depId = this.contract.departmentVO.id
          this.contract.deptName = this.contract.departmentVO.name

          this.form.name = this.form.name == '' ? this.contract.name : this.form.name
          this.form.outline = this.form.outline == '' ? this.contract.outline : this.form.outline
          this.form.isBigCustomer = this.contract.isBigCustomer ? "1" : "0"
          this.form.isBigContract = this.contract.isBigContract ? "1" : "0"
        })
      },
      // 提交项目申请
      createProject() {
        this.form = this.$refs.create.getFromData()
        if (this.form.underLine == "") {
          this.$message.error('请标注本次审批是否已线下通过')
          return
        }

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        this.form.attachments = this.$refs.attachments.getAttachments()

        if (this.form.isLowcost && this.form.ctype == 0) {
          this.form.approvalUserIds = this.form.approvalUserIds.split(",").slice(0, 3).join(",")
        }
        this.form.isLowcost = this.form.isLowcost ? "1" : "0"

        this.formLoading = true
        let _url = !this.form.signId ? '/gc/project/contractsign' : '/gc/project/contractsign/edit'

        console.log(this.form.approvalUserIds)
        // return false

        ajax.post(_url, this.form, (res) => {
          if (this.form.ctype) {
            this.$message.success("提交合同会签审批表成功，请耐心等待领导审批")
          } else {
            this.$message.success("提交合同备案审批表成功，请耐心等待领导审批")
          }

          this.$router.back()
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'contractType'() {
        if (this.contractType == 2) {
          if (this.userData.deptDetail) {
            // 原水
            this.form.ctype = 3
          } else {
            this.form.ctype = 2
          }
        } else {
          this.form.ctype = this.contractType
        }
      },
      'form.ctype'() {
        console.log("修改form.ctype")
        this.approvalUsersData = this.approvalUsers['c31_' + this.form.ctype]
        if (this.form.ctype != 0) {
          // 把清空selectArr 放到合同会签下，合同备案不清空
          this.selectArr = []
          if (this.form.ctype == this.applyInfo.ctype) {
            this.setSelectArr(this.applyInfo, 31, this.form.ctype / 1)
          } else {
            this.setSelectArr("", 31, this.form.ctype / 1)
          }
          switch (this.form.ctype) {
            case "1":
              this.contractType = 1
              break;
            case "2":
            case "3":
              this.contractType = 2
              break;
          }
        }
      },
      'form.isLowcost'() {
        if (this.form.isLowcost && this.form.ctype == 0) {
          let _approvalUsersData = this.approvalUsers['c31_' + this.form.ctype].slice(0, 2)
          _approvalUsersData[1].users = _approvalUsersData[1].users.slice(0, 1)
          this.approvalUsersData = _approvalUsersData
        } else if (this.form.ctype == 0) {
          this.approvalUsers['c31_' + this.form.ctype] = [{
              name: "需求单位审批",
              users: ["分管副总", "总经理"]
            }, {
              name: "审核主体",
              users: ["相关部门(资产运营部/战略企划部)", "财务总监"]
            }],
            this.approvalUsersData = this.approvalUsers['c31_' + this.form.ctype]
        }
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/contract/createContractApproval.vue